import * as tslib_1 from "tslib";
import { EventEmitter, OnInit } from '@angular/core';
import { TranslateService } from 'src/app/common-modules/blue-air-common/translator/translate.service';
import { FlightModel } from 'src/app/core/models/flight-model';
import { SsrBoxContentBase } from '../ssr-box-content-base/ssr-box-content-base';
import { SsrType } from '../ssr-type.enum';
import { SsrsService } from '../ssrs.service';
var SsrBoxContentFlexComponent = /** @class */ (function (_super) {
    tslib_1.__extends(SsrBoxContentFlexComponent, _super);
    function SsrBoxContentFlexComponent(ssrsService, translateService) {
        var _this = _super.call(this, ssrsService) || this;
        _this.ssrsService = ssrsService;
        _this.translateService = translateService;
        _this.saveChangesEvent = new EventEmitter();
        _this.ssrType = SsrType.Flex;
        return _this;
    }
    SsrBoxContentFlexComponent.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
        if (this.flight && this.flight.passengers.length > 0) {
            this.allPassengersEnabled = true;
            if (!this.allPassengersEnabled) {
                this.selectedPassenger = 0;
            }
        }
        if (this.availableSsrs.every(function (s) { return s.paidQuantity == 1; })) {
            this.isFlexAvailable = true;
        }
    };
    SsrBoxContentFlexComponent.prototype.initFlightSsrList = function () {
        var _this = this;
        _super.prototype.initFlightSsrList.call(this);
        if (!this._fullSsrList || !this._flight) {
            return;
        }
        this.notAvailableForSegments = [];
        this._flight.segments.forEach(function (segment) {
            var flightKey = segment.departureStation.iataCode + "_" + segment.arrivalStation.iataCode;
            var avSsrList = _this._fullSsrList.find(function (avSsr) { return avSsr.key === flightKey; });
            if (!avSsrList || !avSsrList.value.length) {
                var seg = new FlightModel();
                seg.initFromSegment(segment, _this.translateService);
                _this.notAvailableForSegments.push(seg);
            }
        });
        this.ssr = this.availableSsrs[0];
    };
    SsrBoxContentFlexComponent.prototype.selectSsrEvent = function (passengerIndex, ssrCode, newSsrQuantity) {
        this.selectSsr(-1, ssrCode, newSsrQuantity);
        this.saveChangesEvent.emit(passengerIndex);
    };
    SsrBoxContentFlexComponent.prototype.resetSsr = function () {
        this.saveChangesEvent.emit();
    };
    SsrBoxContentFlexComponent.prototype.onEnableSameOptionsForAllFlightsChanged = function (value) {
        _super.prototype.onEnableSameOptionsForAllFlightsChanged.call(this, value);
        if (!value)
            return;
        this.saveChangesEvent.emit();
    };
    // override base method
    // for this special ssr (airport-checkin) add the ssr only for segments where it is available
    SsrBoxContentFlexComponent.prototype.applySpecificSsr = function (oldQuantity, newSsrQuantity, ssr, passengerNumber) {
        var _this = this;
        var paidSSRQuantityOverride = this._paidSSROverrides.getPaidQuantity(passengerNumber, ssr.ssrCode);
        var tempNewSsrQuantity = newSsrQuantity - paidSSRQuantityOverride;
        var tempOldSsrQuantity = oldQuantity - paidSSRQuantityOverride;
        while (tempNewSsrQuantity > oldQuantity - paidSSRQuantityOverride) {
            this.flight.segments.forEach(function (segment) {
                var flightKey = segment.departureStation.iataCode + "_" + segment.arrivalStation.iataCode;
                var avSsrList = _this._fullSsrList.find(function (avSsr) { return avSsr.key === flightKey; });
                if (avSsrList && avSsrList.value.find(function (avSsr) { return avSsr.ssrCode === ssr.ssrCode; })) {
                    _this._ssrsService.addSsr(_this.ssrType, ssr.ssrCode, passengerNumber, segment, false);
                }
            });
            tempNewSsrQuantity--;
        }
        while (newSsrQuantity - paidSSRQuantityOverride < tempOldSsrQuantity) {
            this._ssrsService.removeSsr(this.ssrType, ssr.ssrCode, tempOldSsrQuantity, passengerNumber, this.flight, this.applySsrsToSegments);
            tempOldSsrQuantity--;
        }
    };
    SsrBoxContentFlexComponent.prototype.removeAllFlex = function () {
        var _this = this;
        this.passengers.forEach(function (p) {
            _this.removeAllSsrs(p.passenger.passengerNumber);
        });
    };
    SsrBoxContentFlexComponent.prototype.allPassengersEnabledFunc = function () {
        if (this.passengers.length < 2) {
            return false;
        }
        if (this.availableSsrs[0]) {
            for (var property in this.availableSsrs[0].limitPerPassenger) {
                if (this.availableSsrs[0].limitPerPassenger.hasOwnProperty(property)) {
                    if (this.availableSsrs[0].limitPerPassenger[property] === 0) {
                        return false;
                    }
                }
            }
        }
        return true;
    };
    return SsrBoxContentFlexComponent;
}(SsrBoxContentBase));
export { SsrBoxContentFlexComponent };
